export default "<ion-app>\r\n\t<ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n";